import moment from 'moment-timezone'

export const correctTimezone = (time: any) => moment.tz(time, 'UTC').tz(moment.tz.guess())
export const timeFromNow = (time: any) => correctTimezone(time).fromNow()
export const timeFormat = (time: any, fmt: string = 'LLL') => correctTimezone(time).format(fmt)
